import * as yup from 'yup'

export const createOrganizationMemberSchema = yup.object({
  username: yup
    .string()
    .trim()
    .when('email', {
      is: (email: string) => !email,
      then: (schema) => schema.required('Username or Email is required'),
      otherwise: (schema) => schema.optional(),
    }),
  email: yup.string().trim().email('Invalid email'),
  permissions: yup.array().of(yup.string()).optional(),
})
